<template>
  <v-dialog scrollable max-width="600px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn v-on="on">
          <v-icon left>mdi-plus</v-icon>
          Agregar
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>
        <h4>Agregar rbt</h4>
      </v-card-title>
      <v-card-text>

        {{ generacionId}}
        <v-form ref="form" v-model="validForm">
          <v-row>
            <v-col>
              <v-radio-group v-model="rubro" row>
                <v-radio label="Tigo" value="tigo"></v-radio>
                <UploadFile @uploaded="fileUploaded" accept=".csv" />
                <span v-if="fileName"> {{ fileName }}</span>
              </v-radio-group>
              
            </v-col>
          </v-row>
        </v-form>

        <span class="red--text" v-if="errorMessage">{{ errorMessage }}</span>
        <span class="blue--text" v-if="message">{{ message }}</span>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn
          :disabled="!validForm || loading || !fileId"
          color="warning"
          @click="confirmar"
          :loading="loading"
          >PROCESAR</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import UploadFile from "@/components/macheo/UploadFile.vue";

export default Vue.extend({
  props: ["id","generacionId"],
  data() {
    return {
      loading: false,
      showDialog: false,
      nombre: "",
      descripcion: "",
      errorMessage: "",
      message: "",
      fileName: "",
      fileId: null,
      rubro: 'tigo',
      totales: [],
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 100) || "Maximo 100 caracteres",
        counter30: (value) =>
          (value && value.length <= 30) || "Maximo 30 caracteres",
      },
      validForm: false
    };
  },
  mounted() {},
  methods: {
    close() {
      this.$refs.form.reset();
      this.showDialog = false;
    },
    volver() {
      this.fileName = null;
      this.fileId = null;
      this.showDialog = false;
    },
    fileUploaded(uploadedData) {
      console.log("*************", uploadedData);
      this.fileName = uploadedData.file.name;
      this.fileId = uploadedData.fileId;
      //this.fileName = fileName;
    },
    confirmar() {
      this.loading = true;
      this.message = "Procesando archvo, favor aguarde . . .";
      this.errorMessage = '';
      axios
        .put("/rbt/agregar", {
          fileId: this.fileId,
          rubro: this.rubro,
          generacionId: this.generacionId
        })
        .then((response) => {
          this.loading = false;
          this.message = "";
          console.log(response);
          this.close();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    }
  },
  components: {
    UploadFile
  },
});
</script>
